<template>
    <div>
        <md-dialog :md-active.sync="showVedaModal" :md-click-outside-to-close="false" :md-close-on-esc="false">
            <span v-if="!veda_report">
                <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
            </span>
          <md-dialog-content>
            <veda-summary
                :veda-report="veda_report"
                v-if="veda_report && veda_report.success"
                :activeOneScoreButton=true
                @click-one-score = "getVeda(false, 'FromPopupWindow', version == 'Alternative')"
            />
            <md-dialog-actions
              class="action-buttons"
              v-if="veda_report && veda_report.success"
            >
              <md-progress-spinner
                  :md-diameter="30"
                  :md-stroke="3"
                  md-mode="indeterminate"
                  v-if="isUpdating"
              ></md-progress-spinner>
              <md-button
                  class="md-danger"
                  @click="changeStatus('decline')"
                  :disabled="isUpdating"
                  >Decline</md-button
              >
              <md-button
                  class=""
                  @click="changeStatus('withdraw')"
                  :disabled="isUpdating"
                  >Withdraw</md-button
              >
              <md-button
                  class="md-primary"
                  @click="changeStatus('proceed')"
                  :disabled="isUpdating"
                  >Proceed</md-button
              >
            </md-dialog-actions>
          </md-dialog-content>
        </md-dialog>
        <md-dialog :md-active.sync="showVedaModalWithMessage" :md-click-outside-to-close="false" :md-close-on-esc="false">
          <md-dialog-content>
            <p class="message-height" v-html="errorMessage"></p>
            <p class="message-height font-bold" v-html="reasonMessage"></p>
            <div class="action-buttons-cover">
              <md-dialog-actions class="action-buttons">
                  <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"
                                     v-if="isUpdating"></md-progress-spinner>
                  <!--
                  <md-button class="md-success" :disabled="isUpdating" v-if="isStatusFail" @click="retryStatus()">Retry</md-button>
                  <md-button class="md-danger" @click="changeStatus('decline after failed')" :disabled="isUpdating">Decline</md-button>
                  <md-button class="" @click="changeStatus('withdraw after failed')" :disabled="isUpdating">Withdraw</md-button> -->
                  <md-button class="md-primary" @click="changeStatus('proceed after failed')" :disabled="isUpdating">OK</md-button>
              </md-dialog-actions>
            </div>
          </md-dialog-content>
        </md-dialog>
        <veda-summary
            :veda-report="veda_report"
            :error="error"
            :is-file-ban="isFileBan"
            :index="index"
            v-if="veda_report"
            :showActionButtons="true"
            :version="version"
            :activeOneScoreButton=true
            @click-one-score = "getVeda(false, 'FromApplicationWindow', version == 'Alternative')"
        />
        <md-empty-state
            v-if="(version === 'Current'
            && (!veda_report
            || !veda_report.success
            || veda_report.is_credit_file_outdated))"
            md-icon="highlight_off"
            md-label="Credit report not downloaded"
            md-description="Please click the button to download the credit report."
        >
          <div class="veda-button-group">
            <md-button class="md-primary md-sm veda-button" @click="fetchCreditReport(CREDIT_REPORT_TYPES.COMPREHENSIVE)">
                <div class="logo-img">
                    <img :src="logo_veda" />
                </div>
            </md-button>
            <md-button class="md-primary md-sm veda-button" @click="fetchCreditReport(CREDIT_REPORT_TYPES.COMPREHENSIVE_AND_ONE_SCORE)">
                <div class="logo-img">
                    <img :src="logo_veda_and_one_score" />
                </div>
            </md-button>
          </div>
        </md-empty-state>
        <md-empty-state
            v-if="(version === 'Previous' && (!veda_report || !veda_report.success))"
            md-icon="highlight_off"
            md-label="No Previous Credit Report Available">
        </md-empty-state>
        <md-empty-state
            v-if="(version === 'Alternative' && (!veda_report || !veda_report.success))"
            md-icon="highlight_off"
            md-label="No Alternative Credit Report Available">
        </md-empty-state>
        <md-dialog-alert
          :md-active.sync="error_alert.show"
          :md-content="error_alert.message"
          md-confirm-text="Close"
        />
    </div>

</template>

<script>
import {mapGetters} from 'vuex';
import filters from '@/components/utils/filters';
import ValidatedInputs from '@/components/ValidatedInput';
import GroupCard from '@/components/Cards/GroupCard';
import GroupCardRow from '@/components/Cards/GroupCardRow';
import VedaSummary from '@/components/ApplicationSummary/VedaSummary.vue';
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import ConfirmDialog from "../Dialogs/ConfirmDialog";
import veda from "@/components/utils/veda";

export default {
    components: {
        ...ValidatedInputs,
        GroupCard,
        GroupCardRow,
        VedaSummary,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        index: {
            type: [Number, String],
            default: 0,
        },
        logo_veda: {
            type: String,
            default: require("@/assets/img/zink-it-comprehensive.png")
        },
        logo_veda_and_one_score: {
            type: String,
            default: require("@/assets/img/zink-it-comprehensive-and-one-score.png")
        },
        version: {
          default: 'Current',
          required: false,
        },
    },
    data() {
        return {
            showVedaModal: false,
            showVedaModalWithMessage: false,
            isUpdating: false,
            isStatusFail: false,
            failStatus: '',
            error_alert:{
                show: false,
                message:''
            },
            errorMessage : '',
            reasonMessage : '',
            reason : '',
            error_dialog: {
              show: false,
              title: '',
              content: '',
            },
            showPossibleMatchesModal: false,
            isEditing: false,
            declinedNotificationContent: 'Do you wish to send a declined email notification to customer?',
            refreshDialog: false,
            selectedRefreshCreditType: null,
            CREDIT_REPORT_TYPES: {
              COMPREHENSIVE: 'Comprehensive',
              COMPREHENSIVE_AND_ONE_SCORE: 'Comprehensive and One Score',
            },
            invalidRequiredFields: [],
            invalidRecommendedFields: [],
        }
    },
    created() {
      window.addEventListener("beforeunload", this.preventNav)
    },
    computed: {
        ...mapGetters({
            options: 'options',
            application: 'application',
            userHasPermission: 'userHasPermission',
            userHasRole: 'userHasRole'
        }),

        // internal reference to the v-model on this component, handles incomeing and outgoing changes
        applicant: {
            get() {
                return this.value
            },
            set(applicant) {
                this.$emit('input', applicant)
            },
        },

        veda_report: {
            get() {
            if (this.version === 'Current') {
                return this.applicant.veda_report;
            } else if (this.version === 'Previous') {
                return this.applicant.previous_veda_report;
            } else if (this.version === 'Alternative') {
                return this.applicant.alternative_veda_report;
            }
            return {}
            }
        },

        error() {
            if (this.veda_report && this.veda_report.error && this.veda_report.error.length) {
                return this.veda_report.error[0];
            }
            return null;
        },

        isFileBan() {
            return this.error && this.error.code == "file-ban";
        },
    },
    methods: {
        // make all filters available as methods
        ...filters,
        ...veda,
        preventNav(event) {
          if (!this.isEditing) return;
          event.preventDefault();
          event.returnValue = '';
        },
        // NOTE resubmit params refer to whether credit report is to be generated again.
        // NOTE resubmit params is boolean, default value is false
        async sendDeclinedNotification () {
          const resp = await this.showNotification('', this.declinedNotificationContent, 'Yes', 'No')
          if (!resp) {
            return
          }

          await axios.post(`/api/v1/application/send-client-declined-notification`, {
            application_id: this.application.loan.id
          }).catch((error) => {
            console.error(error)
            this.showErrorDialog("Failed to send to notification", true, false);
          })
        },
        async getVeda(resubmit = false, stringOneScoreReport = null, alternative = false) {
          let oneScoreReport = (!!stringOneScoreReport) ? true : false;
          // need to understand which window calls one score in order to behave differently after the answer
          let oneScoreFromAppWindow = (stringOneScoreReport == 'FromApplicationWindow') ? true : false;

          if (resubmit) {
            const res = await this.showNotification(
              "Confirm",
              "This will fetch a new copy of the customers Comprehensive Only credit report and may incur an additional charge. Continue?",
              "Confirm",
              "Cancel"
            );
            if (!res) {
              return;
            }
          }
          if (oneScoreReport) {
            const res = await this.showNotification(
              "Please confirm One Score request",
              "This will fetch a new copy of the credit report including One Score and will incur an additional charge. Continue?",
              "Confirm",
              "Cancel"
            );
            if (!res) {
              return;
            }
          }
          this.$modal.show(WaitingDialog, {
              title: 'Fetching Credit Report...',
              message: 'Please wait whilst we are loading the applicants credit report.',
          });
          try {
            if (this.veda_report && this.veda_report.is_credit_file_outdated) {
              resubmit = true;
            }
            let result = await this.$store.dispatch('request_veda_for_application',
              {
                application_data: this.application,
                applicant_index: this.index,
                resubmit,
                oneScoreReport,
                alternative
              }
            );
            if (result['success']) {
              this.showVedaModal = oneScoreFromAppWindow ? false : true;
              this.$emit('application-change');
              this.closeOpenModals();
            } else {
              this.closeOpenModals();
              this.showVedaErrorDialog(result);
            }
          } catch (e) {
            // if the waiting dialog is open, close it
            this.closeOpenModals();
            if (e && e.response) {
              console.log(e.response.data);
              await this.showNotification(`Fetching Veda report failed for: ${this.name(this.applicant.contact.name)}`, e.response.data, "Ok" );
            }
            if(e instanceof Error) {
              console.log("Server error description:", e);
              await this.showNotification(`Fetching Veda report failed for: ${this.name(this.applicant.contact.name)}`, e, "Ok" );
            }
          }
          this.$store.commit("redirect_after_save", this.application);
          if (!oneScoreFromAppWindow) { //execute in all cases but if not only OneScore request from Application window(not PopUp window)
            // after fetch veda, set isEditing to true to prevent user leave page without generating documents
            this.isEditing = true;
            this.$store.commit('set_is_editing', this.isEditing);
          }
        },

        async fetchComprehensiveAndOneScoreReport(resubmit = false, stringOneScoreReport = null, alternative = false) {
          let oneScoreReport = false;
          // need to understand which window calls one score in order to behave differently after the answer
          let isFromApplicationWindow = (stringOneScoreReport == 'FromApplicationWindow') ? true : false;
          let bothComprehensiveAndOneScore = true;
          if (resubmit) {
            const res = await this.showNotification(
              "Confirm",
              "This will fetch a new copy of the customers Comprehensive and One Score credit report and may incur an additional charge. Continue?",
              "Confirm",
              "Cancel"
            );
            if (!res) {
              return;
            }
          }

          this.$modal.show(WaitingDialog, {
              title: 'Fetching Credit Report...',
              message: 'Please wait whilst we are loading the applicants credit report.',
          });
          try {
            if (this.veda_report && this.veda_report.is_credit_file_outdated) {
              resubmit = true;
            }
            let result = await this.$store.dispatch('request_veda_for_application',
              {
                application_data: this.application,
                applicant_index: this.index,
                resubmit,
                oneScoreReport,
                alternative,
                bothComprehensiveAndOneScore
              }
            );
            if (result['success']) {
              this.showVedaModal = isFromApplicationWindow ? false : true;
              this.$emit('application-change');
              this.closeOpenModals();
            } else {
              this.closeOpenModals();
              this.showVedaErrorDialog(result);
            }
          } catch (e) {
            // if the waiting dialog is open, close it
            this.closeOpenModals();
            if (e && e.response) {
              console.log(e.response.data);
              await this.showNotification(`Fetching Veda report failed for: ${this.name(this.applicant.contact.name)}`, e.response.data, "Ok" );
            }
            if(e instanceof Error) {
              console.log("Server error description:", e);
              await this.showNotification(`Fetching Veda report failed for: ${this.name(this.applicant.contact.name)}`, e, "Ok" );
            }
          }
          this.$store.commit("redirect_after_save", this.application);
        },
        showVedaErrorDialog(result) {
          const httpStatusCode = Number(result?.credit_report?.response_http_status_code);

          if (httpStatusCode === 404) {
            this.errorMessage = `Equifax has returned <span style="font-weight:bold">NO MATCHING RESULT</span>.`;
            this.reasonMessage = `Double-check that all information has been entered accurately. New requests will incur another Equifax charge.`;

            // If there are missing or invalid recommended fields
            if (this.invalidRecommendedFields.length > 0) {
              const message = `<br>The following fields are not required but can improve the chance of a successful match:
                <span style="font-weight:bold">
                  <br>* ${this.invalidRecommendedFields.join('<br> *')}
                </span>`;
              this.reasonMessage += `. ${message}`;
            }
          } else if (httpStatusCode === 503) {
            this.errorMessage = `Equifax has returned an <span style="font-weight:bold">ERROR</span> below.`;

            if (this.veda_report?.error) {
              const vedaErrors = [];
              this.veda_report.error.forEach(error => vedaErrors.push(error.detail)); // Using forEach instead of map
              this.reasonMessage = `Errors: ${vedaErrors.join(', ')}`;
            }
          } else {
            this.errorMessage = `Equifax has returned an <span style="font-weight:bold">ERROR</span>. Please try again later.`;

            if (this.veda_report?.error) {
              const vedaErrors = [];
              this.veda_report.error.forEach(error => vedaErrors.push(error.detail)); // Using forEach instead of map
              this.reasonMessage = `Errors: ${vedaErrors.join(', ')}`;
            }
          }

          this.showVedaModalWithMessage = true;
        },
        async fetchCreditReport(creditReportType) {
          // If the current file is banned give a notification warning
          if (this.isFileBan) {
            const res = await this.showNotification(
              "Confirm",
              "Equifax response advised a File Ban was in place - unless this has been lifted by the applicant you will receive the same response again and be billed for a new search",
              "Confirm",
              "Cancel"
            );
            if (!res) {
              return;
            }
          }
          let validated = await this.validateBeforeFetchCreditReport();
          if (!validated) {
            return;
          }
          if (creditReportType === this.CREDIT_REPORT_TYPES.COMPREHENSIVE) {
            return this.getVeda();
          }
          if (creditReportType === this.CREDIT_REPORT_TYPES.COMPREHENSIVE_AND_ONE_SCORE) {
            return this.fetchComprehensiveAndOneScoreReport();
          }
          this.showErrorDialog('There was an issue when fetching the credit report. Please contact technical support team.', true);
        },
        async validateBeforeFetchCreditReport() {
          let contactData = this.applicant?.contact;
          let addressData = this.applicant?.addresses?.current?.address;
          let previousAddressData = this.applicant?.addresses?.previous[0]?.address;
          let driverLicense = this.applicant?.personal_details?.identifications[0]?.id_number;

          // If either parent object is null or undefined, log an error and return false
          if (!contactData || !addressData) {
            this.showErrorDialog("Applicant Data is missing", true, false);
            return false;
          }

          //Reset the invalid fields array
          this.invalidRequiredFields.length = 0;
          this.invalidRecommendedFields.length = 0;
          const isInvalid = (field) => !field || field.toString().trim() === '';

          if (isInvalid(contactData.name?.firstname)) this.invalidRequiredFields.push('First Name');
          if (isInvalid(contactData.name?.lastname)) this.invalidRequiredFields.push('Last Name');
          if (isInvalid(contactData.gender)) this.invalidRequiredFields.push('Gender');
          if (isInvalid(contactData.date_of_birth)) this.invalidRequiredFields.push('Date of Birth');
          if (isInvalid(addressData.post_code)) this.invalidRequiredFields.push('Postcode');
          if (isInvalid(addressData.state)) this.invalidRequiredFields.push('State');
          if (isInvalid(addressData.street_name)) this.invalidRequiredFields.push('Street Name');
          if (isInvalid(addressData.street_number)) this.invalidRequiredFields.push('Street Number');
          if (isInvalid(addressData.street_type)) this.invalidRequiredFields.push('Street Type');
          if (isInvalid(addressData.suburb)) this.invalidRequiredFields.push('Suburb');

          // If there are invalid fields, show an error dialog and return false
          if (this.invalidRequiredFields.length > 0) {
            let errorMsg = `The following fields <span style="font-weight:bold">MUST</span>
              be completed before credit report can be requested:
              <span style="font-weight:bold">
                <br>* ${this.invalidRequiredFields.join('<br>* ')}
              </span>`;

            this.showErrorDialog(errorMsg, true, false);
            return false;
          }

          if (isInvalid(driverLicense)) this.invalidRecommendedFields.push('Driver License');
          if (!previousAddressData) {
            this.invalidRecommendedFields.push('Previous Address Information');
          } else {
            if (isInvalid(previousAddressData.post_code)) this.invalidRecommendedFields.push('Previous Address Postcode');
            if (isInvalid(previousAddressData.state)) this.invalidRecommendedFields.push('Previous Address State');
            if (isInvalid(previousAddressData.street_name)) this.invalidRecommendedFields.push('Previous Address Street Name');
            if (isInvalid(previousAddressData.street_number)) this.invalidRecommendedFields.push('Previous Address Street Number');
            if (isInvalid(previousAddressData.street_type)) this.invalidRecommendedFields.push('Previous Address Street Type');
            if (isInvalid(previousAddressData.suburb)) this.invalidRecommendedFields.push('Previous Address Suburb');
          }
          // If there are missing or invalid recommended fields
          if (this.invalidRecommendedFields.length > 0) {
            let message = `The following fields are not required but
            can improve the chance of a successful match:
              <span style="font-weight:bold">
                <br>* ${this.invalidRecommendedFields.join('<br>* ')}
              </span>`;


            const res = await this.showNotification(
              "Confirm",
              message,
              "Proceed",
              "Cancel"
            );
            if (!res) {
              return false;
            }
          }

          let latestCreditRequest = this.application?.applicants?.[0]?.latest_veda_request;
          if (latestCreditRequest) {
            if (parseInt(latestCreditRequest.response_http_status_code) !== 404) {
              return true;
            }

            let contactData = this.applicant?.contact;
            let addressData = this.applicant?.addresses?.current?.address;
            let driverLicense = this.applicant?.personal_details?.identifications[0]?.id_number;

            let stringPayload = latestCreditRequest.request_payload;
            let payload = JSON.parse(stringPayload);

            // Compare contact data
            if (contactData.name?.firstname !== payload.first_name) return true;
            if (contactData.name?.lastname !== payload.surname) return true;
            if (contactData.date_of_birth !== payload.date_of_birth) return true;
            if (contactData.gender.charAt(0) !== payload.gender.charAt(0)) return true;

            // Compare address data
            let currentAddress = payload.current_address;
            if (addressData.street_number !== currentAddress.street_number) return true;
            if (addressData.street_name !== currentAddress.street_name) return true;
            if (addressData.street_type !== currentAddress.street_type) return true;
            if (addressData.suburb !== currentAddress.suburb) return true;
            if (addressData.state !== currentAddress.state) return true;
            if (addressData.post_code !== currentAddress.post_code) return true;

            //Compare Driver License
            if (driverLicense !== payload.drivers_licence) return true;
            const res = await this.showNotification(
              "Confirm",
              'A response of <span style="font-weight:bold">No Matching Results</span> has already been returned from Equifax with the details provided. You will be billed for another request if you proceed.',
              "PROCEED",
              "CANCEL");
            if (!res) {
              return false;
            }
          }
          return true;
        },
        showNotification(title, message, confirmText, cancelText = null) {
          return this.$modal.show(ConfirmDialog, {
            title,
            message,
            confirmText,
            cancelText
          })
        },
        closeOpenModals(){
          if (this.$modal.submit){
            this.$modal.submit();
          }
        },
        hasMarketingLead () {
          return this.application.owners.some(owner=> owner.name.name === 'Marketing Lead' && owner.email === 'marketing@zink.com.au')
        },
        async checkVoiForGreenVeda() {
            if (this.check_veda_green_status(this.veda_report) &&
                this.application.loan.type == 'Consumer' &&
                this.userHasRole('Agent') &&
                this.hasMarketingLead()) {
                try {
                    let result = await this.$store.dispatch('request_voi_for_application',
                        {
                            application_data: this.application,
                            applicant_id: this.applicant.id
                        });
                    this.voi_data = JSON.parse(result.data);
                    await this.$store.dispatch('backfill_voi', {
                        applicant_id: this.applicant.id
                    });
                } catch (e) {
                    console.error('failed to request voi');
                    console.error(e);
                }
            }
        },
        async changeStatus(newStatus) {
            this.isUpdating = true;
            if (newStatus == 'withdraw') {
                this.setStatusAndReason('Lost', 'Withdrawn', 'Veda Withdrawn', 'Withdrawn after Credit Report fetch.');
            }
            if (newStatus == 'decline') {
              this.setStatusAndReason('Lost', 'Withdrawn', 'Veda Declined', 'Declined after Credit Report fetch.');
            }
            if (newStatus == 'withdraw after failed') {
              this.setStatusAndReason('Lost', 'Withdrawn', 'Veda Withdrawn', 'Withdrawn after failed Credit Report fetch.');
            }
            if (newStatus == 'decline after failed') {
              this.setStatusAndReason('Lost', 'Withdrawn', 'Veda Declined', 'Declined after failed Credit Report fetch.');
            }
            if (newStatus == 'withdraw' || newStatus == 'decline' || newStatus == 'withdraw after failed' || newStatus == 'decline after failed') {
                try {
                    //refresh application data once status is changed
                  await this.$store.dispatch('update_application_status', {
                    application_id: this.application.loan.id,
                    stage: this.application.loan.status.stage,
                    status: this.application.loan.status.status,
                    reason: this.application.loan.status.reason,
                    comment: this.application.loan.status.comment,
                  });
                  //refresh workbasket once the status is changed
                  this.$store.commit('set_work_basket', null);

                  // If application declined, send notification to applicant.
                  if (newStatus == 'decline') {
                    this.sendDeclinedNotification()
                  }

                  //close the modal
                  this.showVedaModal = false;
                  this.showVedaModalWithMessage = false;
                  this.isUpdating = false;
                } catch (error) {
                    console.log(error);
                    this.isStatusFail = true;
                    this.failStatus = newStatus;
                    alert('Error changing the status to: ' + newStatus);
                    this.showVedaModal = false;
                    this.isUpdating = false;
                }
            } else {
                // check for auto fetch voi
                if (this.veda_report && this.veda_report.success === true) {
                  await this.checkVoiForGreenVeda()
                }
                //proceed generates prelim, credit guide, credit quote
                try {
                  if (!this.userHasRole('Dealer Agent')) {
                    let result = await axios.post(`/api/v1/application/${this.application.loan.id}/generateDocuments`, this.application);
                    if (Object.keys(result.data).length > 0) {
                      this.showErrorDialog('Documents generated and mailed to customer', true, false);
                    }
                  }
                  this.showVedaModal = false
                  this.showVedaModalWithMessage = false;
                  this.isUpdating = false
                  window.removeEventListener('beforeunload', this.preventNav);
                } catch(error) {
                    this.showErrorDialog('There was issue sending documents to client, please do it manually.', true);
                    console.log(error);
                    this.isUpdating = false
                }
            }
            this.isEditing = false;
            this.$store.commit('set_is_editing', this.isEditing);
          //  TODO: remove this part (here and in actions.js) once 100% sure the backend backfill is working
          // this.$store.commit('prefillDataFromVeda', this.applicant)
        },
        //retry the process if failed
        retryStatus(){
          this.changeStatus(this.failStatus);
        },
        showErrorDialog(message, flag, isShowVedaModalWithMessage){
          this.showVedaModal = false;
          this.showVedaModalWithMessage = isShowVedaModalWithMessage;
                this.error_alert={
                  message: message,
                    show: flag
                };
        },
        setStatusAndReason(stage, status, reason, comment){
          this.application.loan.status.status = status;
          this.application.loan.status.stage = stage;
          this.application.loan.status.reason = reason;
          this.application.loan.status.comment = comment;
        },
        async removeCreditReport(applicantId, auditMessage) {
          this.isUpdating = true;
          let payload = {
            reasons: auditMessage,
          };
          try {
            await axios.post(`/api/v1/applicant/${applicantId}/delete_current_veda_report`, payload);
            this.applicant.veda_report = null;
          } catch (e) {
            this.showErrorDialog('There was issue when delete the credit report.', true);
            console.log(e);
          } finally {
            this.isUpdating = false
          }
        }
    },
    filters: {
        // make all filters available as filters
        ...filters,
    },
};
</script>
<style scoped>
.md-progress-spinner {
    padding: 17px;
    margin-left: 5vw;
}

.action-buttons {
    bottom: 52px;
    margin-left: 40%;
    margin-bottom: -50px;
}

button.veda-button {
  border-radius: 5px !important;
  max-width: 420px;
}
.action-buttons-cover{
  float: left;
  margin-top: 50px;
  width: 100%;
}
.message-ul{
  padding-left: 150px;
  padding-right: 100px;
}
.message-height{
  line-height: 2rem;
}
.font-bold{
  font-weight: bold;
}

.veda-button-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 100px;
}

.md-empty-state {
  max-width: none;
}

</style>
